module.exports = __webpack_public_path__ + "img/hori4.7eb8ff5d.png";